import React from "react";
import { useColorModeValue } from "@chakra-ui/system";
import { Text } from "@chakra-ui/layout";
import { Stat, StatHelpText, StatArrow } from "@chakra-ui/stat";
import { IconButtonUnstyled } from "../icon-button-unstyled";

export interface FluctuationProps
  extends Omit<React.HTMLProps<HTMLSpanElement>, "type"> {
  type: "increase" | "decrease" | "unchanged" | "new" | "";
  amount?: string;
}

export const Fluctuation = (props: FluctuationProps) => {
  const { type, amount } = props;
  const increaseColor = useColorModeValue("red.600", "red.200");
  const decreaseColor = useColorModeValue("purple.800", "purple.200");

  if (type === "new") {
    return <Text fontSize="xs">new</Text>;
  }
  if (type === "increase") {
    return (
      <Stat>
        <StatHelpText color={increaseColor}>
          <StatArrow type="increase" color={increaseColor} />
          {amount}
        </StatHelpText>
      </Stat>
    );
  }
  if (type === "decrease") {
    return (
      <Stat>
        <StatHelpText color={decreaseColor}>
          <StatArrow type="decrease" color={decreaseColor} />
          {amount}
        </StatHelpText>
      </Stat>
    );
  }
  return (
    <IconButtonUnstyled
      aria-label="순위 변동 없음"
      w="10px"
      h="2px"
      bg="gray.700"
    />
  );
};
